import facebook from "../static/svg/facebook.svg";
import twitter from "../static/svg/twitter.svg";
import insta from "../static/svg/insta.svg";
import pinterest from "../static/svg/pinterest.svg";
import youtube from "../static/svg/youtube.svg";
import linkedin from "../static/svg/linkedin.svg";
import evolve from "../static/svg/evolve-logo.svg";
import { Container, Flex, Footer, Image, Text } from "@mantine/core";

function Footr() {
	return (
		<Footer
			style={{
				background: "#192535",
				border: "none",
				position: "relative",
			}}
		>
			<Container
				fluid
				className="container-fluid"
				style={{ background: "#040F1F" }}
			>
				<div className="row">
					<Flex
						justify="center"
						className="col-md-3 col-lg-2 column1 text-center"
					>
						<Flex
							gap="lg"
							justify="center"
							align="center"
							direction="row"
						>
							<a
								href="https://www.facebook.com/ivisit.io"
								target="_blank"
							>
								<Image src={facebook} width={8} />
							</a>
							<a
								href="https://twitter.com/ivisitsg"
								target="_blank"
							>
								<Image src={twitter} width={15} />
							</a>
							<a
								href="https://www.linkedin.com/company/ivisit-io"
								target="_blank"
							>
								<Image src={linkedin} width={18} />
							</a>
							<a
								href="https://www.pinterest.com/ivisitsingapore"
								target="_blank"
							>
								<Image src={pinterest} width={15} />
							</a>
							<a
								href="https://www.youtube.com/@ivisitsingapore"
								target="_blank"
							>
								<Image src={youtube} width={15} />
							</a>
						</Flex>
					</Flex>

					<div className="col-md-4 col-lg-6 col-xl-7  column2 text-center">
						<hr
							style={{
								marginTop: "21px",
								height: "2px",
								backgroundColor: "#09254E",
								border: "1px solid #09254E",
							}}
						></hr>
					</div>
					<div className="col-md-3 col-lg-3 col-xl-2 column3 text-center">
						<Text
							size="xs"
							align="center"
							color="rgb(173, 181, 189)"
							pt={14}
							style={{
								fontSize: "10px",
							}}
						>
							Terms & Conditions | Privacy Policy
						</Text>
					</div>
					<div className="col-md-1 column4 text-center">
						<Image
							src={evolve}
							align="center"
							width="auto"
							pb={10}
							pt={12}
						/>
					</div>
				</div>
			</Container>
		</Footer>
	);
}
export default Footr;
